import { useState } from 'react';
import { useQuery } from 'react-query';

import { parseErrors, Toast } from 'helpers';
import { getCustomerTickets } from 'queries';
import { JsonDataItem } from 'types';

export const useCustomerTickets = (status: '0' | '1' | null, customerId?: string) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
  const { data, isLoading } = useQuery(
    [
      'get-tickets',
      'customer',
      customerId,
      {
        currentPage,
        recordsPerPage,
        status,
      },
    ],
    getCustomerTickets,
    {
      enabled: !!customerId,
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  const paginationMetadata = {
    total: data?.meta?.total || 0,
    current_page: currentPage,
    pageSize: 5,
    onChange: (page: number, pageSize: number) => {
      setCurrentPage(page);
      setRecordsPerPage(pageSize);
    },
  };

  return {
    tickets: data?.data,
    isTicketsLoading: isLoading,
    paginationMetadata,
  };
};
